import React from 'react'
import {
  required,
  SimpleForm,
  TextInput,
  Edit,
  DateInput,
  AutocompleteInput,
  FormDataConsumer,
  NumberInput,
  useGetOne,
} from 'react-admin'
import { Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import RichTextInput from 'ra-input-rich-text'
import { makeStyles } from '@material-ui/core/styles'
import { CustomToolbar } from './CustomToolbarForPageEdit'
import CharacterCounter from './InputTextwithCounter'
import CheckboxLabels from './CheckBox'
import MyColorPicker from './MyColorPicker'

import { countryList } from './../../constants'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    flexGrow: 1,
  },
  input: {
    marginBottom: '-20px',
  },
  inputHidden: {
    display: 'none',
  },
  text: {
    color: '#0000008A',
    fontSize: '12px',
  },
  autocomplete1: {
    width: 200,
    display: 'inline-block',
    transform: 'translateY(-4px)',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  button1: {
    marginRight: '10px',
  },
  w_300: {
    width: 300,
  },
}))

export default function RunningTextEdit(props) {
  const { source, ...rest } = props
  const { data } = useGetOne('advertisements', props.id)

  const classes = useStyles()
  const [dataForm, setDataForm] = React.useState({})
  const RunningTextTitle = ({ record }) => {
    return <span>Running Text: {record ? `"${record.id}"` : ''}</span>
  }

  return (
    <Edit title={<RunningTextTitle />} {...props}>
      <SimpleForm toolbar={<CustomToolbar dataForm={dataForm} />}>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextInput source="id" disabled fullWidth validate={required()} />
            </Grid>
            {data?.runningTextLocale?.map((data, index) => {
              return (
                <Grid item xs={12}>
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{
                      color: 'black',
                      marginBottom: '10px',
                      fontSize: '14px',
                      fontWeight: '700',
                    }}
                  >
                    Running text for locale {Object.keys(data)[0].split('_').pop()}
                  </Typography>
                  <CharacterCounter source={Object.keys(data)[0]} {...rest} />
                </Grid>
              )
            })}
            <Grid item xs={12}>
              <RichTextInput source="description" validate={required()} />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                component="h6"
                style={{ color: 'black', marginBottom: '10px', fontSize: '14px' }}
              >
                Pick a Color for the Running Text
              </Typography>
              <MyColorPicker source="textColor" {...rest} />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                component="h6"
                style={{ color: 'black', marginBottom: '10px', fontSize: '14px' }}
              >
                Apply Running Text For?
              </Typography>
              <div>
                <CheckboxLabels type="checkbox" source="user_type" {...rest} />
              </div>
            </Grid>
            <Grid item xs={12}>
              <NumberInput
                fullWidth
                source="max_shown"
                label="Max. Shown / Customer"
                className={classes.input}
                validate={required()}
              />
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', gap: 16 }}>
              <DateInput
                label="Start Date"
                source="start"
                parse={(v) => new Date(v)}
                validate={required()}
                fullWidth
              />
              <DateInput
                label="End Date"
                source="end"
                parse={(v) => new Date(v)}
                validate={required()}
                fullWidth
              />
            </Grid>
            <TextInput source="running_text" className={classes.inputHidden} />
            <Grid item xs={12}>
              <AutocompleteInput
                fullWidth
                label="Country"
                source="country"
                className={classes.input}
                choices={countryList}
                validate={required()}
              />
            </Grid>
          </Grid>

          <FormDataConsumer>
            {({ formData, ...rest }) => {
              setDataForm(formData)
            }}
          </FormDataConsumer>
        </div>
      </SimpleForm>
    </Edit>
  )
}
